import React, { useState, useEffect } from 'react';
import { Alert, Col, Container, Row } from 'react-bootstrap';
import '../../../styles/RegDashboard.css';
import { AccountInfo } from './AccountInfo';
import { ServicesAndSolutions } from './ServicesAndSolutions';
import Loading from '../../utility/Loading';
import { POCTable } from './POCTable';
import { RegMemberTable } from './RegMemberTable';
import { POCRegistrationModal } from './Modals/POCRegistrationModal';
import { MultiAccountModal } from './Modals/MultiAccountModal';
import { AccountRegistrationModal } from './Modals/AccountRegistrationModal';
import { MemberSubmissionQueue } from './MemberSubmissionQueue';
import { HHIEButton } from '../../utility/HHIEButton';


export function RegDashboard() {
    const [loading, setLoading] = useState(true);
    const [user, setUser] = useState(null);
    const [account, setAccount] = useState(null);
    const [accounts, setAccounts] = useState(null);
    const [tempAccounts, setTempAccounts] = useState(null);
    const [selectAccounts, setSelectAccounts] = useState(false);
    const [accountPos, setAccountPos] = useState(0);
    const [users, setUsers] = useState(null);
    const [members, setMembers] = useState(null);
    const [pocIsFullyRegistered, setPOCIsFullyRegistered] = useState();
    const [disableAdd, setDisableAdd] = useState(false);
    const [showAlert, setShowAlert] = useState(true);
    const [showSubmittableMembers, setShowSubmittableMembers] = useState(true);
    const [accountVerify, setAccountVerify] = useState(false);
    const [userIsAdmin, setUserIsAdmin] = useState(false);
    const [duplicates, setDuplicates] = useState();

    useEffect(() => {
        try {
            // extract from storage one time, save string into a const variable since it should not change.
            const userString = sessionStorage.getItem("user");
            // parse out immutable userString from storage
            const currentUser = JSON.parse(userString);
            setUser(currentUser);
            // don't allow user to do anything until security questions are complete
            if (!currentUser.securityQuestionsComplete && currentUser.isPOCUser) {
                setTimeout(() => {
                    window.location.href = "/set-security-questions";
                }, 3000);
                return;
            }
            if (!currentUser.isPOCUser) {
                Promise.resolve(CheckUserIsAdmin(currentUser));
            }
            var currentAcct = 0;
            setAccountPos(currentAcct);
            // If user is an HHIE User, the account should already be stored;
            if (!currentUser.isPOCUser) {
                var acct = JSON.parse(sessionStorage.getItem("account"))
                var accts = [acct];
                retrieveAccounts(accts);
            }
            else {
                fetch('api/registration/RetrieveAccountNames/' + currentUser.sfid)
                    .then((response) => {
                        response.json()
                            .then((accts) => {
                                console.log(accts)
                                if (accts.errors !== null && accts.errors !== "") alert(accts.errors)
                                setTempAccounts(accts.message);
                                if (accts.message.length === 1) {
                                    retrieveAccounts(accts.message);
                                    setAccountPos(currentAcct);
                                }
                                else if (accts.message.length < 1) {
                                    alert("You don't seem to have access to any accounts. Please contact the HHIE. \n Email helpdesk@hawaiihie.org or call (808) 441-1374.");
                                    window.location.href = "/logout";
                                }
                                else {
                                    try {

                                        var acctIds = sessionStorage.getItem("accounts");
                                        if (acctIds !== null) {
                                            retrieveAccounts(JSON.parse(acctIds));
                                        }
                                        else {
                                            setSelectAccounts(true);
                                        }
                                    }
                                    catch (ex) {
                                        console.log(ex);
                                        sessionStorage.setItem("currentAcct", accts.message[0].id);
                                        setSelectAccounts(true);
                                    }
                                }
                            })
                    })
            }

            const memberIsAttachedToPOCUserAccount = (currentUser.memberID !== null && currentUser.memberID !== 0);
            setPOCIsFullyRegistered((memberIsAttachedToPOCUserAccount && (currentUser.isPOCUser)) || !currentUser.isPOCUser);
        }
        catch (ex) {
            console.error(ex);
        }
    }, []);


    const CheckUserIsAdmin = async (currentUser) => {
        const isAdmin =
            await fetch('api/admin/GetAdminRoleBySfId/' + currentUser.sfid)
                .then(async (isAdminResponse) => {
                    try {
                        return await isAdminResponse.json().then(json => {
                            if (json.errors !== null && json.errors !== "") alert(json.errors)
                            return json.message
                        });
                    }
                    catch (ex) {
                        return console.log(ex);
                    }
                })
                .catch((error) => {
                    console.log("Error getting a response: " + error);
                });
        setUserIsAdmin(isAdmin);
    }

    useEffect(() => {
        if (account) {
            fetch('api/registration/IsVerificationNeeded/' + account.id)
                .then((response) => {
                    response.json()
                        .then((resp) => {
                            if (resp.errors !== null && resp.errors !== "") alert(resp.errors)
                            setAccountVerify(resp.message)
                        })
                })
        }
    }, [account])

    const retrieveAccounts = (retrievedAccts) => {
        var accts = [];
        for (let retrievedAcct of retrievedAccts) {
            fetch('api/registration/RetrieveAccount/' + retrievedAcct.id)
                .then((response) => {
                    response.json()
                        .then((acct) => {
                            if (acct.errors !== null && acct.errors !== "") alert(acct.errors)
                            // add account to accts list
                            accts.push(acct.message);
                            if (retrievedAccts.length === accts.length) {
                                var currentAcctstring = sessionStorage.getItem("currentAcct");
                                if (currentAcctstring !== null) {
                                    for (var i = 0; i < accts.length; i++) {
                                        if (currentAcctstring === accts[i].id) {
                                            setAccountPos(i);
                                        }
                                    }
                                }
                                else {
                                    sessionStorage.setItem("currentAcct", accts[0].id);
                                    setAccountPos(0);
                                }
                                setAccounts(accts);
                            }
                        })
                        .catch((error) => {
                            console.log("retrieved Account error: ", error);
                        })
                })
                .catch((error) => {
                    console.log("Error getting a response: ", error);
                });
        }
    }
    // store accounts in session storage when found
    useEffect(() => {
        if (accounts && tempAccounts && (accounts.length === tempAccounts.length)) {
            setLoading(false);
            sessionStorage.setItem("accounts", JSON.stringify(accounts.map(a => { return { id: a.id } })));
        }
    }, [accounts, tempAccounts])

    useEffect(() => {
        var dups;
        let members2 = members;
        if (members) {
            for (let m1 in members) {
                for (let m2 in members2) {
                    if (members2[m2].id !== members[m1].id
                        && members[m1].firstName?.toUpperCase() === members2[m2].firstName?.toUpperCase()
                        && members[m1].lastName?.toUpperCase() === members2[m2].lastName?.toUpperCase()
                        && members[m1].dob === members2[m2].dob) {
                        if (dups) {
                            let newVal = true;
                            for (let d in dups) {
                                if (members[m1].firstName?.toUpperCase() === dups[d].firstName?.toUpperCase()
                                    && members[m1].lastName?.toUpperCase() === dups[d].lastName?.toUpperCase()
                                    && members[m1].dob === members2[m2].dob) {
                                    newVal = false;
                                }
                            }
                            if (newVal) dups.push(members[m1]);
                        }
                        else dups = [members[m1]];
                    }
                }
            }
            setDuplicates(dups);
        }
    }, [members])

    useEffect(() => {
        var pos = parseInt(accountPos);
        if (accounts && accountPos !== null && pos >= 0) {
            setLoading(true);
            if (accounts[pos].basics.poCs?.length > 50) accounts[pos].basics.poCs = [];
            sessionStorage.setItem("currentAcct", accounts[pos].id);
            sessionStorage.setItem("account", JSON.stringify(accounts[pos].basics));
            setAccount(accounts[pos]);
            setUsers(accounts[pos].poCs);
            setMembers(accounts[pos].members);
            if (user.isPOCUser && (accounts[pos].acctId !== 0 || !accounts[pos].legalName?.length || !accounts[pos].phone?.length || !accounts[pos].location.street?.length
                || !accounts[pos].location.city?.length || !accounts[pos].location.state?.length || !accounts[pos].location.zipCode?.length || !accounts[pos].participantType?.length)) {
                setDisableAdd(true);
            }

            setLoading(false);
        }
    }, [accountPos, accounts])

    useEffect(() => {
        if (members) {
            let acct = account;
            acct.members = members;
            setAccount(acct);
            sessionStorage.setItem("account", JSON.stringify(acct.basics));
        }
    }, [members])

    const modifyAccount = (acct) => {
        sessionStorage.setItem("account", JSON.stringify(acct.basics));
        var pos = parseInt(accountPos);
        let accts = accounts;
        accts[pos] = acct;
        setAccounts(accts);
    };

    const submitAccountAlert = () => {

        const formData = new FormData();
        formData.append("user", user.sfid)
        formData.append("account0", account.id)

        const requestOptions = {
            method: "POST",
            body: formData
        }
        fetch('/api/POCUser/POCAlertWrongAccounts', requestOptions)
            .then((response) => {
                response.json()
                    .then((text) => {
                        if (text.errors !== null && text.errors !== "") alert(text.errors)
                        else alert(text.message);
                        window.location.href = "/registration-dashboard"
                    })
                    .catch((error) => {
                        console.log("wrongAccounts Text Error: " + error);
                    })
            })
            .catch((error) => {
                console.log("wrongAccounts Response Error: " + error);
            });
    }

    const submitVerification = () => {
        setAccountVerify(false)
        let customVerify = {
            "AccountId": account.id,
            "VerifierSfid": user.sfid
        }

        const requestOptions = {
            method: "POST",
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(customVerify)
        }
        fetch('/api/registration/VerifyAccount', requestOptions)
            .then((response) => {
                response.json()
                    .then((success) => {
                        if (success.errors !== null && success.errors !== "") alert(success.errors)
                    })
                    .catch((error) => {
                        console.log("wrongAccounts Text Error: " + error);
                    })
            })
            .catch((error) => {
                console.log("wrongAccounts Response Error: " + error);
            });
    }

    return (
        <>
            <MultiAccountModal user={user} accounts={tempAccounts} selectAccounts={selectAccounts} setAccounts={(acctIds) => { retrieveAccounts(acctIds); setTempAccounts(acctIds) }} setSelectAccounts={(val) => { setSelectAccounts(val) }} />
            {!loading ?
                <>
                    <POCRegistrationModal user={user} pocIsFullyRegistered={pocIsFullyRegistered} />
                    <AccountRegistrationModal accountIsFullyRegistered={!disableAdd} />
                    <Container>
                        {!user.isPOCUser ?
                            <Row style={{ paddingTop: "10px", paddingBottom: "10px" }}>
                                <Col>
                                    <div className="d-flex justify-content-end">
                                        <HHIEButton
                                            variant="primary"
                                            size="sm"
                                            onClick={
                                                () => {
                                                    window.location.href = '/account-dashboard'
                                                }
                                            }
                                            title="Return to Full List"
                                        />
                                    </div>
                                </Col>
                            </Row>
                            :
                            <>
                                {accounts.length > 1 ?
                                    <Row>
                                        <Col>
                                            {/* Left Paging Button for Multi Accounts */}
                                            <div className="d-flex justify-content-start">
                                                <HHIEButton
                                                    variant="primary"
                                                    size="sm"
                                                    onClick={() => {
                                                        sessionStorage.setItem("currentAcct", accounts[parseInt(accountPos) - 1].id);
                                                        setAccountPos(parseInt(accountPos) - 1);
                                                        setShowAlert(true);
                                                    }}
                                                    disabled={parseInt(accountPos) === 0}
                                                    title={(parseInt(accountPos) !== 0 ? "< " + accounts[parseInt(accountPos - 1)].legalName : "<")}
                                                />
                                            </div>
                                        </Col>
                                        <Col xs={8} className="d-flex justify-content-center">
                                            <Alert
                                                variant="primary"
                                                style={{
                                                    paddingTop: 4
                                                    , paddingBottom: 4
                                                    , borderRadius: '10px'
                                                }}
                                                onClose={() => { setShowAlert(false) }}
                                                show={showAlert}
                                                dismissible
                                            >
                                                Don't think you should have access to this account?
                                                <hr />
                                                <div
                                                    style={{
                                                        margin: 'auto'
                                                        , textAlign: 'center'
                                                    }}
                                                >
                                                    <HHIEButton
                                                        variant="primary"
                                                        size="sm"
                                                        onClick={() => { submitAccountAlert() }}
                                                        title="Alert the HHIE"
                                                    />
                                                </div>
                                            </Alert>
                                        </Col>
                                        <Col>
                                            {/* Right Paging Button for Multi Accounts */}
                                            <div className="d-flex justify-content-end">
                                                <HHIEButton
                                                    variant="primary"
                                                    size="sm"
                                                    onClick={() => {
                                                        sessionStorage.setItem(
                                                            "currentAcct"
                                                            , accounts[parseInt(accountPos) + 1].id
                                                        );
                                                        setAccountPos(parseInt(accountPos) + 1);
                                                        setShowAlert(true);
                                                    }}
                                                    disabled={parseInt(accountPos) >= (accounts.length - 1)}
                                                    title={(parseInt(accountPos) < (accounts.length - 1) ? accounts[parseInt(accountPos + 1)].legalName + " >" : ">")}
                                                />
                                            </div>
                                        </Col>

                                    </Row>
                                    :

                                    <Col className="d-flex justify-content-center">
                                        <Alert variant="primary" style={{ paddingTop: 4, paddingBottom: 4 }} onClose={() => { setShowAlert(false) }} show={showAlert} dismissible> Don't think you should have access to this account?
                                            <HHIEButton
                                                variant="primary"
                                                onClick={() => { submitAccountAlert() }}
                                                title="Alert the HHIE"
                                            />
                                        </Alert>
                                    </Col>
                                }
                            </>}

                        <Col className="d-flex justify-content-center">
                            <Alert
                                variant="warning"
                                style={{
                                    paddingTop: 4
                                    , paddingBottom: 4
                                    , borderRadius: '10px'
                                }}
                                show={accountVerify}
                            >
                                This organization needs to be verified! <b>Please review your organization and member information before confirming.</b>
                                <hr />
                                <div
                                    style={{
                                        margin: 'auto'
                                        , textAlign: 'center'
                                    }}
                                >
                                    <HHIEButton
                                        variant="primary"
                                        size="sm"
                                        onClick={() => { submitVerification() }}
                                        title="Verify"
                                        disabled={!user.isPOCUser}
                                    />
                                </div>
                            </Alert>
                        </Col>

                        <AccountInfo
                            account={account}
                            user={user}
                            userIsAdmin={userIsAdmin}
                            modifyAccount={(acct) => { modifyAccount(acct) }}
                        />
                        <div style={{ padding: "3px" }} />
                        <ServicesAndSolutions
                            account={account}
                            user={user}
                        />
                        <div style={{ padding: "3px" }} />
                        <POCTable
                            user={user}
                            users={users}
                        />
                        <div style={{ padding: "3px" }} />
                        <MemberSubmissionQueue
                            user={user}
                            userIsAdmin={userIsAdmin}
                            account={account}
                            accounts={accounts}
                            Members={members}
                            DisableAdd={disableAdd}
                            setMembers={(mems) => { setMembers(mems) }}
                            setAccounts={(accts) => { setAccounts(accts) }}
                            showSubmittableMembers={showSubmittableMembers}
                            hideSubmittableMembers={() => { setShowSubmittableMembers(false); }}
                        />
                        <div style={{ padding: "3px" }} />
                        {duplicates &&
                            <Alert
                                variant="warning"
                                style={{
                                    paddingTop: 4
                                    , paddingBottom: 4
                                    , borderRadius: '10px'
                                }}
                                show={duplicates}>
                                <div>There may be more more than one of the following members in this account. Please ensure all member names and birth dates are correct.</div>
                                <ul>{duplicates?.map(dup => { return <li>{dup.firstName} {dup.lastName}</li> })}</ul>
                            </Alert>
                        }
                        <RegMemberTable
                            Account={account}
                            Members={members}
                            setMembers={
                                (adjustedMembers) => {
                                    setMembers(adjustedMembers);
                                    setShowSubmittableMembers(true)
                                }
                            }
                            DisableAdd={disableAdd}
                        />
                        <div style={{ padding: "30px" }} />
                    </Container>
                </>
                : <Loading message={<div>Loading. . . Please wait</div>} />
            }
        </>
    );
}
